import { createSlice } from "@reduxjs/toolkit";
import { Report } from "services/report/report.service";
import { toast } from 'react-toastify';

export const reportListSlice = createSlice({
  name: "reportList",
  initialState: {
    reportList: [],
    reportListLoading: false,
    reportListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(Report.pending, (state) => {
      state.reportListLoading = true
    });

    builder.addCase(Report.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Promise resolved 👌');

      state.reportList = action.payload
      state.reportListLoading = false
      state.reportListError = null
    });

    builder.addCase(Report.rejected, (state, action) => {
      toast.dismiss();
      toast.error('Promise rejected 🤯 😣')

      state.reportListLoading = false
      state.reportListError = action.error?.message
    });
  },
});

